import type { EditorView, PMNode } from '@bangle.io/prosemirror-plugins';

const FRONTMATTER_NODE = 'frontmatter';

/** YAML body inside the leading frontmatter node, or `null` when absent. */
export function readFrontmatterTextFromDoc(doc: PMNode): string | null {
  const first = doc.firstChild;
  if (first?.type.name !== FRONTMATTER_NODE) {
    return null;
  }
  return first.textContent;
}

/**
 * Replace or insert the document's frontmatter node with `text` (YAML body,
 * no fences). Empty / whitespace-only text removes the node when present.
 */
export function replaceFrontmatterText(
  view: EditorView,
  text: string,
): boolean {
  const type = view.state.schema.nodes[FRONTMATTER_NODE];
  if (!type) {
    return false;
  }

  const first = view.state.doc.firstChild;
  const trimmed = text.trim();

  if (!trimmed) {
    if (first?.type === type) {
      view.dispatch(view.state.tr.delete(0, first.nodeSize));
    }
    return true;
  }

  const content = view.state.schema.text(text);
  const node = type.create(null, content);

  if (first?.type === type) {
    view.dispatch(view.state.tr.replaceWith(0, first.nodeSize, node));
  } else if (!view.state.doc.type.contentMatch.matchType(type)) {
    return false;
  } else {
    view.dispatch(view.state.tr.insert(0, node));
  }
  return true;
}
